import { Tab, TabProps, Tabs, TabsProps } from '@mui/material';

//
//

export type AppTabsProps = Omit<TabsProps, 'textColor'> & { to?: any };

export const AppTabs = ({ tabs, children, ...props }: AppTabsProps & { tabs?: TabProps[] }) => (
  <Tabs
    variant="scrollable"
    scrollButtons
    allowScrollButtonsMobile
    sx={{ borderBottom: 1, borderColor: 'divider' }}
    // TabIndicatorProps={{ hidden: true }}
    {...props}
  >
    {tabs?.length &&
      tabs.map(({ key, label, ...tabProps }) => (
        <AppTab key={key || tabProps?.value} label={label} {...tabProps} />
      ))}

    {children}
  </Tabs>
);

//

export const AppTab = ({ label, key, ...props }: TabProps) => {
  return <Tab key={key || props?.value} label={label} sx={{ overflow: 'visible' }} {...props} />;
};
